import get from 'lodash.get';

import { emptyArray } from '../../../default-props/empty';

export const selectSelectedReturnIds = (state) => get(state, 'selectedReturnIds', emptyArray);
export const selectCount = (state) => get(selectSelectedReturnIds(state), 'length');
